class Config {

  readonly uploadUrl: string;

  private readonly filesBase: string;

  constructor() {
    const apiBase = process.env.VUE_APP_API_BASE || 'https://schularena.paloma.one/api';
    this.uploadUrl = `${apiBase}/recordings/`;

    this.filesBase = process.env.VUE_APP_FILES_BASE || 'https://schularena.paloma.one/files';
  }

  recordingFile(recordingId: string): string {
    return `${this.filesBase}/recordings/${recordingId}`;
  }
}

export default new Config();
